import { RouteComponentProps } from '@reach/router';
// import { getAccessToken } from 'api/Utils';
// import { ClassTemplateEditor } from 'containers/Tasks/CompanyManagement/PDPClass/ClassTemplateEditor';
import React from 'react';
// import { useSelector } from 'react-redux';
// import { createOrUpdateClass } from 'store/pdp/pdpSlice';
// import { PDPClass } from 'store/pdp/types';
// import { item_createNewSurvey } from 'store/providers/providerSlice';
// import { IProviderItemView, ITags } from 'store/providers/providerTypes';
// import { appDispatch, RootState } from 'store/store';
// import { updateSurvey } from 'store/survey/surveySlice';
// import { ISurveyItem, ISurveyView } from 'store/survey/surveyTypes';
// import { requireSeveralUser } from 'store/users/usersSlice';

interface IClassTemplateSelectorProps {
  classId?: string;
  termId?: string;
  companyId?: string;
  pdpId?: string;
}

const EmtpyRoute: React.FC<
  IClassTemplateSelectorProps & RouteComponentProps
> = () => {
  // const company = useSelector(
  //   (state: RootState) => state.companies.data[Number(props.companyId)]
  // );
  // const pdpState = useSelector(
  //   (state: RootState) => state.pdp.pdpMap[Number(props.pdpId)!]
  // );

  // const stateTags = useSelector((state: RootState) => state.providers.tags);

  // const providerIds = useSelector((state: RootState) =>
  //   Object.values(state.providers.map).reduce((current: number[], it) => {
  //     if (it.data?.managingCompanyId === Number(props.companyId))
  //       current.push(it.data.id);
  //     return current;
  //   }, [] as number[])
  // );
  // let tags = {} as ITags['data'];
  // providerIds.forEach((id: number) => {
  //   tags = {
  //     ...tags,
  //     ...stateTags?.[id]?.data,
  //   };
  // });
  // const token = useSelector((state: RootState) => getAccessToken(state));

  // const relatedProviders = useSelector(
  //   (state: RootState) =>
  //     state.companies.data[Number(props.companyId)].relatedProviders
  // );

  // const companyMembers = useSelector(
  //   (state: RootState) => state.companies.data[company.id].members
  // );

  // const pdpID = useMemo(() => Number(props.pdpId), [props.pdpId]);
  // const classId = useMemo(() => Number(props.classId), [props.classId]);
  // const showCalendar = props.classId === 'calendar';
  // const clazz = showCalendar ? undefined : pdpState?.classes?.[classId];

  // const updateSurveyHandler = async (
  //   surveyData: ISurveyView,
  //   providerSurveyItemData: ISurveyItem
  // ) => {
  //   return appDispatch(updateSurvey({ surveyData, providerSurveyItemData }));
  // };

  // const createProviderSurvey = async (item: IProviderItemView) => {
  //   return appDispatch(item_createNewSurvey({ item }));
  // };

  // const requireSeveralUserHandler = async (usersList: number[]) => {
  //   return appDispatch(requireSeveralUser({ usersList }));
  // };

  // const createOrUpdateClassHandler = async (
  //   pdpClass: PDPClass,
  //   pdpId: number,
  //   skipConflictCheck: boolean | undefined
  // ) => {
  //   return appDispatch(
  //     createOrUpdateClass({ clazz: pdpClass, pdpId, skipConflictCheck })
  //   );
  // };

  return (
    <></>
    // <ClassTemplateEditor
    //   key={clazz!.id}
    //   topic={pdpState.topics![clazz!.topicId]}
    //   templateClass={clazz!}
    //   company={company}
    //   tags={tags}
    //   relatedProviders={relatedProviders}
    //   saveClass={(it, skipConflictCheck) =>
    //     createOrUpdateClassHandler(it, pdpID, skipConflictCheck)
    //   }
    //   closeClass={() => {
    //     navigate('../class');
    //   }}
    //   requireSeveralUser={requireSeveralUserHandler}
    //   companyMembers={companyMembers}
    //   createProviderSurvey={createProviderSurvey}
    //   updateSurvey={updateSurveyHandler}
    //   token={token}
    //   terms={pdpState.terms}
    //   pdpId={pdpID}
    // />
  );
};

export default EmtpyRoute;
